module.exports = __webpack_public_path__ + "static/media/logo.87a009ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.png
// module id = 1244
// module chunks = 0